import { createContext } from 'react';

interface GoogleOAuthContextType {
  isGoogleOAuthAvailable: boolean;
}

const GoogleOAuthContext = createContext<GoogleOAuthContextType>({
  isGoogleOAuthAvailable: false,
});

export { GoogleOAuthContext };
